export const ORIGINATION_BOARD_COLUMNS = [
  {
    key: 'approvedInstrumentation',
    title: 'Aprobadas',
    shortTitle: 'Aprobadas',
    description: 'Aprobación intermedia: falta instrumentar antes de que sea crédito activo.',
    shortDescription: 'Falta instrumentar',
    statuses: [14, 8],
    statusLabels: ['Solicitud aprobada', 'Oferta pendiente de docu'],
    responsible: 'Comercial / cliente',
    primaryActionLabel: 'Continuar instrumentación',
    interactionMode: 'action',
    isDeferred: false,
    requiresCommercialAction: true
  },
  {
    key: 'observed',
    title: 'Observadas',
    shortTitle: 'Observadas',
    description: 'Hay una observación que requiere corrección, respuesta o seguimiento.',
    shortDescription: 'Requieren atención',
    statuses: [13, 20, 11],
    statusLabels: ['Solicitud observada', 'Oferta observada', 'Pago observado'],
    responsible: 'Comercial con feedback de financiera',
    primaryActionLabel: 'Resolver observacion',
    interactionMode: 'action',
    isDeferred: false,
    requiresCommercialAction: true
  },
  {
    key: 'pendingCommercial',
    title: 'Pendiente comercial',
    shortTitle: 'Pendiente',
    description: 'El comercial o cliente debe completar datos o documentación inicial.',
    shortDescription: 'Completar datos/docs',
    statuses: [0, 12],
    statusLabels: ['Creada', 'Solicitud pendiente de docu'],
    responsible: 'Comercial / cliente',
    primaryActionLabel: 'Completar',
    interactionMode: 'action',
    isDeferred: false,
    requiresCommercialAction: true
  },
  {
    key: 'inAnalysis',
    title: 'En análisis',
    shortTitle: 'Análisis',
    description: 'La financiera o el sistema están evaluando la solicitud.',
    shortDescription: 'Evaluación financiera',
    statuses: [80, 2],
    statusLabels: ['Análisis Motores', 'Análisis de riesgo'],
    responsible: 'Sistema / financiera',
    primaryActionLabel: 'Esperar evaluación',
    interactionMode: 'passive',
    isDeferred: false
  },
  {
    key: 'settlement',
    title: 'Para liquidar',
    shortTitle: 'Liquidación',
    description: 'La solicitud está en análisis de pago o lista para liquidarse.',
    shortDescription: 'Pago/liquidación',
    statuses: [9, 21],
    statusLabels: ['Análisis de pago', 'Para liquidar'],
    responsible: 'Financiera / liquidación',
    primaryActionLabel: 'En seguimiento',
    interactionMode: 'passive',
    isDeferred: false
  },
  {
    key: 'active',
    title: 'Créditos activos',
    shortTitle: 'Activos',
    description: 'Crédito ya otorgado o activo. No es lo mismo que solicitud aprobada.',
    shortDescription: 'Otorgados',
    statuses: [5],
    statusLabels: ['Activo'],
    responsible: 'Financiera / sistema',
    primaryActionLabel: 'Crédito otorgado',
    interactionMode: 'passive',
    isDeferred: false
  },
  {
    key: 'closed',
    title: 'Cerradas',
    shortTitle: 'Cerradas',
    description: 'Casos terminales o históricos. Se cargan solo al seleccionar esta columna.',
    shortDescription: 'Histórico',
    statuses: [3, 4, 7, 96, 97, 98, 99],
    statusLabels: [
      'Rechazo automático',
      'Rechazo analista',
      'Oferta desistida',
      'Anulada manualmente',
      'Cancelado',
      'Vencida',
      'Anulado'
    ],
    responsible: 'Historico',
    primaryActionLabel: 'Caso cerrado',
    interactionMode: 'passive',
    isDeferred: true
  }
];

export const DEFAULT_ORIGINATION_BOARD_COLUMN = 'pendingCommercial';

export const ORIGINATION_BOARD_COLUMN_BY_KEY = ORIGINATION_BOARD_COLUMNS.reduce((acc, column) => {
  acc[column.key] = column;
  return acc;
}, {});

// Solo estados donde retomar el flujo comercial de instrumentación tiene sentido.
export const ORIGINATION_CONTINUABLE_STATUSES = new Set([14, 8]);
// Alta inicial: completar datos/documentación antes de análisis de riesgo.
export const ORIGINATION_COMPLETABLE_STATUSES = new Set([0, 12]);
export const ORIGINATION_DISCARDABLE_STATUSES = new Set([14, 8, 13, 11, 20, 9]);

export const isClosedBoardColumn = (columnKey) => columnKey === 'closed';
